module.exports = __webpack_public_path__ + "img/scene5-16.51b12d24.png";